import{withBaseSelectStyle as e}from"./BaseSelect.js";import t from"@mui/joy/Autocomplete";var o=e(t);export{o as BaseAutocomplete};
//# sourceMappingURL=BaseAutocomplete.js.map